/**
 * Client-side companion to the authoritative server-route containment latch.
 *
 * This prevents the existing Inbox journey from writing `approved`/`failed`
 * draft states for an operation the server will reject. It is not an
 * authorization boundary; the server latch remains authoritative.
 */
export const LINKEDIN_SEND_CONTAINMENT_MESSAGE =
  'LinkedIn sending is temporarily disabled while a safety upgrade is in progress.';

export function isLinkedInSendContained(): boolean {
  return true;
}
